import { request } from '../request';

export function fetchGetProductList(data?: Api.Product.ProductParams) {
  return request({
    url: '/developer-platform/api/product/detail/page',
    method: 'POST',
    data
  });
}

export function fetchAddProduct(data: object) {
  return request<number>({
    url: '/developer-platform/api/product/add',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function fetchDelProduct(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/delete',
    method: 'POST',
    data
  });
}

export function fetchGetBaseProduct(params: any) {
  return request({
    url: '/developer-platform/api/product/detail/baseInfo',
    method: 'GET',
    params
  });
}

export function fetchUpdBaseProduct(data: object) {
  return request<number>({
    url: '/developer-platform/api/product/update',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
}

export function fetchBelongToCategory(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/update/belongToCategory',
    method: 'POST',
    data
  });
}

export function fetchChangeReleaseStatus(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/update/changeReleaseStatus',
    method: 'POST',
    data
  });
}

export function fetchAddProdFunction(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/add/function',
    method: 'POST',
    data
  });
}

export function fetchAddProdGroup(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/add/functionGroup',
    method: 'POST',
    data
  });
}

export function fetchAddPullFunc(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/add/pullFunctions',
    method: 'POST',
    data
  });
}

export function fetchDeleteFunc(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/delete/function',
    method: 'POST',
    data
  });
}

export function fetchDelProdGroup(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/delete/functionGroup',
    method: 'POST',
    data
  });
}

export function fetchGetDetailFunc(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/detail/function',
    method: 'POST',
    data
  });
}

export function fetchGetProdFuncList(params: any) {
  return request({
    url: '/developer-platform/api/product/function/detail/functions',
    method: 'GET',
    params
  });
}

export function fetchUpdateFunc(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/update/function',
    method: 'POST',
    data
  });
}

export function fetchUpdProdGroup(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/update/functionGroup',
    method: 'POST',
    data
  });
}

export function fetchUpdateRelateFunc(data: any) {
  return request<number>({
    url: '/developer-platform/api/product/function/update/relateFunctions',
    method: 'POST',
    data
  });
}

export function fetchGetProdCategoryList(params: any) {
  return request<number>({
    url: '/developer-platform/api/category/detail/queryCategoryList',
    method: 'GET',
    params
  });
}

export function fetchGetApplicationList(data: any) {
  return request({
    url: '/developer-platform/api/product/application/list',
    method: 'POST',
    data
  });
}

export function fetchAddApplication(data: any) {
  return request({
    url: '/developer-platform/api/product/application/add',
    method: 'POST',
    data
  });
}

export function fetchGetFirmwareList(data: any) {
  return request({
    url: '/developer-platform/api/firmware/detail/page',
    method: 'POST',
    data
  });
}

export function fetchGetListAvailable() {
  return request({
    url: '/developer-platform/api/product/application/listAvailable',
    method: 'POST'
  });
}




export function fetchAddFirmware(data: any) {
  return request<number>({
    url: '/developer-platform/api/firmware/addBase',
    method: 'POST',
    data,
  });
}

export function fetchDownloadFirmware(params: any) {
  return request({
    url: '/developer-platform/api/firmware/getDownloadUrl',
    method: 'GET',
    params,
  });
}

export function fetchDisableFirmware(data: any) {
  return request({
    url: '/developer-platform/api/firmware/update/disable',
    method: 'POST',
    data
  });
}

export function fetchEnableFirmware(data: any) {
  return request({
    url: '/developer-platform/api/firmware/update/enable',
    method: 'POST',
    data
  });
}

export function fetchGetFirmwareDetail(data: any) {
  return request({
    url: '/developer-platform/api/firmware/detail/getInfo',
    method: 'POST',
    data
  });
}


export function fetchEditFirmware(data: any) {
  return request({
    url: '/developer-platform/api/firmware/updateBase',
    method: 'POST',
    data,
  });
}

export function fetchUpdateFirmwareFile(data: any) {
  return request({
    url: '/developer-platform/api/firmware/updateFile',
    method: 'POST',
    data,
  });
}

export function fetchDelFirmware(data: any) {
  return request({
    url: '/developer-platform/api/firmware/delete',
    method: 'POST',
    data
  });
}

export function fetchGetUnderCateGroupList(data: any) {
  return request({
    url: '/developer-platform/api/product/function/detail/categoryFunctionUnderGroup',
    method: 'POST',
    data
  });
}

export function fetchAddPullProdFunc(data: any) {
  return request({
    url: '/developer-platform/api/product/function/add/pullFunctionsWithRelate',
    method: 'POST',
    data
  });
}



export function fetchGetCredential() {
  return request({
    url: '/developer-platform/api/upload/getCredential',
    method: 'GET',
  });
}


export function fetchGetPreMultipartUpload(data: any) {
  return request({
    url: '/developer-platform/api/upload/preMultipartUpload',
    method: 'POST',
    data
  });
}

export function fetchSyncMultipartUpload(data: any) {
  return request({
    url: '/developer-platform/api/upload/syncMultipartUpload',
    method: 'POST',
    data
  });
}

export function fetchAbortMultipartUpload(data: any) {
  return request({
    url: '/developer-platform/api/upload/abortMultipartUpload',
    method: 'POST',
    data
  });
}

export function fetchCompleteMultipartUpload(data: any) {
  return request({
    url: '/developer-platform/api/upload/completeMultipartUpload',
    method: 'POST',
    data
  });
}


export function fetchGetListScene(params: any) {
  return request({
    url: '/developer-platform/api/product/scene/get',
    method: 'GET',
    params
  });
}
export function fetchGetProductInfo(params: any) {
  return request({
    url: '/developer-platform/api/i18n/dp/product/info',
    method: 'GET',
    params
  });
}


export function fetchSaveListScene(data: any) {
  return request({
    url: '/developer-platform/api/product/scene/save',
    method: 'POST',
    data
  });
}

export function fetchSetProductLang(data: any) {
  return request({
    url: '/developer-platform/api/i18n/dp/product/set',
    method: 'POST',
    data
  });
}

export function fetchExportProductLang(params: any) {
  return request({
    url: '/developer-platform/api/i18n/dp/product/export',
    method: 'get',
    responseType: 'blob',
    params
  });
}

export function fetchImportProductLang(data: any) {
  return request({
    url: '/developer-platform/api/i18n/dp/product/import',
    method: 'post',
    data
  });
}

export function fetchGetDevFuncJson(params: any) {
  return request({
    url: '/developer-platform/api/product/function/getDeviceProductFunctionDetails',
    method: 'GET',
    params
  });
}


export function fetchPostSaveFirmwareType(data: any) {
  return request({
    url: '/developer-platform/api/firmware/type/config/save',
    method: 'post',
    data
  });
}


export function fetchGetFirmwareType() {
  return request({
    url: '/developer-platform/api/firmware/type/config/typeList',
    method: 'GET',
  });
}

export function fetchGetFirmwareTypeInfo() {
  return request({
    url: '/developer-platform/api/i18n/dp/firmwareType/info',
    method: 'GET',
  });
}


export function fetchSetFirmwareType(data: any) {
  return request({
    url: '/developer-platform/api/i18n/dp/firmwareType/set',
    method: 'post',
    data
  });
}


export function fetchUpdateScope(data: any) {
  return request({
    url: '/developer-platform/api/firmware/update/scope/confirm',
    method: 'post',
    data
  });
}



export const fetchGetClientList = () => {
  return request({
    url: '/developer-platform/api/tenant/list',
    method: 'post',
  });
};


export function fetchCopyProduct(data: any) {
  return request({
    url: '/developer-platform/api/product/copy',
    method: 'post',
    data
  });
}
